/**
 * Paleta de cores por índice usada pelos códigos clássicos `[§K n]`.
 * Índices 0–15: convenção clássica de 16 cores; 16+: extensão. Valores
 * necessários para renderizar igual mensagens escritas em outros clientes.
 */

function invertLuminosity(hex: string): string {
  const n = Number.parseInt(hex.slice(1), 16);
  const r = ((n >> 16) & 255) / 255;
  const g = ((n >> 8) & 255) / 255;
  const b = (n & 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h /= 6;
  }
  const l2 = 1 - l;
  const q = l2 < 0.5 ? l2 * (1 + s) : l2 + s - l2 * s;
  const p = 2 * l2 - q;
  const conv = (t: number) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };
  const to = (v: number) => Math.round(v * 255).toString(16).padStart(2, '0');
  return `#${to(s === 0 ? l2 : conv(h + 1 / 3))}${to(s === 0 ? l2 : conv(h))}${to(s === 0 ? l2 : conv(h - 1 / 3))}`;
}

export const TALEMARK_PALETTE: readonly string[] = [
  '#ffffff', '#000000', '#000080', '#008000', '#ff0000', '#800000', '#800080', '#ff7f00',
  '#ffff00', '#00ff00', '#008080', '#00ffff', '#0000ff', '#ff00ff', '#808080', '#c0c0c0',
  '#f0f0f0', '#e0e0e0', '#888888', '#eeeeee', '#d6d6d6', '#fff8e6', '#003399', '#bf810d',
  '#ad2b2b', '#602369', invertLuminosity('#f47193'), '#13935a', '#d83f1a',
];

/** Cor de um parâmetro `[§K …]`: índice da paleta, `#RRGGBB` ou nome CSS. null se inválido. */
export function resolveTalemarkColor(param: string): string | null {
  const p = param.trim();
  if (!p) return null;
  if (/^\d+$/.test(p)) return TALEMARK_PALETTE[Number(p)] ?? null;
  if (/^#[0-9a-f]{6}$/i.test(p)) return p.toLowerCase();
  if (/^#[0-9a-f]{8}$/i.test(p)) return `#${p.slice(3).toLowerCase()}`; // #AARRGGBB
  if (/^[a-z]{3,20}$/i.test(p)) return p.toLowerCase();
  return null;
}
